export const IN_PROGRESS = 1;
export const ACCEPTED = 2;
export const REJECTED = 3;
export const TIMEDOUT = 4;



// WEBPACK FOOTER //
// ./js/constants/CashoutRequestStatus.js